$ = global.$ = global.jQuery = window.$ = window.jQuery = require('jquery');
global.bootstrap = window.bootstrap = require('bootstrap');

require('select2');
require('../../../Framework/assets/js/cms-select2');
require('../../../Framework/assets/js/cms-datepicker');

require('../../../Framework/assets/js/cms-autocomplete');
require('../../../Framework/assets/js/cms-ajax-form');

require('./statistics-categories')
require('./statistics-widget-charts')
require('./search-filter')

const alertList = document.querySelectorAll('.alert')
const alerts = [...alertList].map(element => new bootstrap.Alert(element))


$(document).ready(function () {

    document.addEventListener("DOMContentLoaded", function() {
        var button = document.getElementById("toggleMenu");
        var menu = document.querySelector(".mobile-menu");

        button.addEventListener("click", function() {
            menu.classList.toggle("show");
        });
    });



});
document.addEventListener("DOMContentLoaded", function() {
    const filterToggleButton = document.getElementById("filter-toggle-button");
    if(!filterToggleButton) return;
    const openIcon = filterToggleButton.querySelector(".open");
    const closeIcon = filterToggleButton.querySelector(".close");

    filterToggleButton.addEventListener("click", function() {
        if (!filterToggleButton.classList.contains("active")) {
            openIcon.style.display = "inline";
            closeIcon.style.display = "none";
        } else {
            openIcon.style.display = "none";
            closeIcon.style.display = "inline";
        }
    });
});

//Mobile search field placeholder change
$(function () {
    var $input = $('.search-form');
    var desktopPlaceholder = $input.attr('placeholder');
    var mobilePlaceholder = $input.data('mobile-placeholder');

    function updatePlaceholder() {
        $input.attr('placeholder', window.innerWidth < 768 ? mobilePlaceholder : desktopPlaceholder);
    }

    updatePlaceholder();
    $(window).on('resize', updatePlaceholder);
});

